module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1600.6952ea8e.svg";